import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ArticlePage from "./pages/ArticlePage";
import CategoryPage from "./pages/CategoryPage";
import AdminPage from "./pages/AdminPage";
import ArchivePage from "./pages/ArchivePage";
import DeskPage from "./pages/DeskPage";
import SubscribePage from "./pages/SubscribePage";
import WirePage from "./pages/WirePage";
import MastheadPage from "./pages/MastheadPage";
import LegalPage from "./pages/LegalPage";
import TierFeedPage from "./pages/TierFeedPage";
import LibraryPage from "./pages/LibraryPage";
import { Toaster } from "./components/ui/sonner";
import { api } from "./lib/api";
import { AuthProvider, AuthCallback, useAuth } from "./lib/auth";
import PaywallModal from "./components/PaywallModal";

// Fire a lightweight visit ping on every route change
const VisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin")) return;
    api.post("/track-visit", {
      path: pathname,
      referrer: typeof document !== "undefined" ? document.referrer : "",
    }).catch(() => {});
  }, [pathname]);
  return null;
};

// After OAuth returns with #session_id=..., exchange it for a session cookie
// then refresh the auth state.
const AuthReturn = () => {
  const { refresh } = useAuth();
  return <AuthCallback onDone={() => refresh()} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AuthReturn />
          <VisitTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/section/:cat" element={<CategoryPage />} />
            <Route path="/wire" element={<WirePage />} />
            <Route path="/desk" element={<DeskPage />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/library/premium" element={<LibraryPage tier="premium" />} />
            <Route path="/library/professional" element={<LibraryPage tier="professional" />} />
            <Route path="/masthead/:section" element={<MastheadPage />} />
            <Route path="/legal/:section" element={<LegalPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/my/premium" element={<TierFeedPage tier="premium" />} />
            <Route path="/my/professional" element={<TierFeedPage tier="professional" />} />
            {/* Catch-all: any unknown path redirects to home so we never render a blank page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <PaywallModal />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
